import i18n from '../../../../../i18n'

type LegalLinksType = {
  privacyPolicy: string
  ica: string
}

const HELP_BASE_URL = 'https://help.doordash.com/dashers/s'

export const getLegalLinksForCountry = (currentSignUpCountry: {
  [k: string]: boolean
}): LegalLinksType => {
  const currentLanguage = i18n.getCurrentLocale().replace('-', '_')

  if (currentSignUpCountry.isJP) {
    return {
      ica: `${HELP_BASE_URL}/ica-jp?language=${currentLanguage}`,
      privacyPolicy: `${HELP_BASE_URL}/privacy-policy-jp?language=${currentLanguage}`,
    }
  } else if (currentSignUpCountry.isCA) {
    return {
      ica: `${HELP_BASE_URL}/ica-ca?language=${currentLanguage}`,
      privacyPolicy: `${HELP_BASE_URL}/privacy-policy-ca?language=${currentLanguage}`,
    }
  } else if (currentSignUpCountry.isAU) {
    return {
      ica: `${HELP_BASE_URL}/ica-au?language=${currentLanguage}`,
      privacyPolicy: `${HELP_BASE_URL}/privacy-policy-au?language=${currentLanguage}`,
    }
  }

  // DE links don't exist yet it seems
  return {
    ica: `${HELP_BASE_URL}/ica-us?language=${currentLanguage}`,
    privacyPolicy: `${HELP_BASE_URL}/privacy-policy-us?language=${currentLanguage}`,
  }
}
